module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_features_02-7079daa3aab045d61a62b52ebfe60b7d.png";